module.exports = __webpack_public_path__ + "static/image/font/pc/bmdohyeon-2@3x.jpg?faca2c94";